import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';

import styles from '../../assets/jss/components/snackbarStyle';

const useStyles = makeStyles(styles);

const CustomSnackbar = ({
    autoHideDuration, message, onClose, open, severity,
}) => {
    const classes = useStyles();
    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
        >
            <Alert severity={severity} onClose={onClose}>
                <div className={classes.message}>{message}</div>
            </Alert>
        </Snackbar>
    );
};

CustomSnackbar.defaultProps = {
    autoHideDuration: 3000,
    onClose: undefined,
    severity: 'error',
};

CustomSnackbar.propTypes = {
    autoHideDuration: PropTypes.number,
    message: PropTypes.node.isRequired,
    onClose: PropTypes.func,
    open: PropTypes.bool.isRequired,
    severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
};

export default CustomSnackbar;
